/* eslint-disable import/no-default-export */
export default {
  status: {
    REQUESTED: 'I-9 Demandé',
    IN_PROGRESS: 'I-9 En cours',
    ALL_FORMS_RECEIVED: 'I-9 Soumis',
    // FORM_SUBMITTED: 'I-9 Submitted',
    ALL_REQUIRED_SUBMISSION_FINALIZED: 'I-9 Approuvé',
    SUBMISSION_ACCEPTED: 'I-9 Soumis',
    SUBMISSION_RESTARTED: 'I-9 Recommencé',
    SUBMISSION_REJECTED: 'I-9 Rejeté',
    NEW_FORM_SUBMISSION_REQUESTED: 'I-9 Demandé',
  },
  statusFilter: {
    REQUESTED: 'Demandée',
    ALL_FORMS_RECEIVED: 'Soumise',
    IN_PROGRESS: 'En cours',
    ALL_REQUIRED_SUBMISSION_FINALIZED: 'Approuvée',
  },
  apiKeyRequired: 'La clé API est requise',
  webhookSecretRequired: 'Le secret Webhook est requis',
  i9SetupLabel: 'Informations sur la configuration de l’intégration de I-9.',
  linkI9Label: 'Lier le compte I-9',
  setupStep: "Étapes nécessaires pour mettre en place l'intégration I-9",
  finalNote: 'Soyez certain de toujours commencer par la première étape si vous recommencez le processus.',
  webHookTitle: 'Pour configurer le secret du webhook.',
  submitBtn: 'Confirmer',
  viewBtn: 'Vue',
  closeBtn: 'Fermer',
  save: 'Sauvegarder',
  checks: 'Vérifications',
  keysUrlLabel: 'Clés et URL',
  apiKeyLabel: 'Clé API',
  webhookUrlLabel: 'URL du Webhook',
  subDomainLabel: 'Sous-domaine',
  usernameLabel: "Nom d'utilisateur",
  passwordLabel: 'Mot de passe',
  apiKeyPlaceholder: 'Saisissez la clé API WorkBright',
  subDomainPlaceholder: 'Saisissez le sous-domaine',
  usernamePlaceholder: "Saisissez le nom d'utilisateur WorkBright",
  passwordPlaceholder: 'Saisissez le mot de passe WorkBright',
  linkToI9: "Si vous n'avez pas créé un compte I-9, vous pouvez le faire à ls'aide du lien ci-dessous:",
  selectRequiredLabel: 'Sélectionnez les vérifications des antécédents requis par défaut',
  apiGenerationTitle: 'Pour générer une clé API',
  stepGenerateWorkBrightAPIKey:
    'Connectez-vous à votre compte WorkBright puis visitez l’adresse  ‘https://VOTRE_SOUS_DOMAINE.workbright.com/admin/api_settings/edit‘ (remplacez VOTRE_SOUS_DOMAINE par votre sous-domaine)',
  stepCopyAPIKey: 'Activez le bouton ‘Accès à l’API’ puis copiez la clé API générée.',
  webHookGenerationTitle: 'Pour générer un webhook',
  stepGenerateWorkBrightWebhook1:
    "Accédez à la page des paramètres de webhook située à l'adresse https://VOTRE_SOUS_DOMAINE.workbright.com/settings/webhooks.’",
  stepGenerateWorkBrightWebhooks2:
    'Créez un point de terminaison de webhook en entrant un nom, une URL et en sélectionnant les événements que vous souhaitez que votre point de terminaison reçoive.',
  i9ConfigurationTitle: 'Pour connecter votre compte WorkBright à AppyHere',
  stepCopyWBCredentials:
    'En utilisant la clé API copiée et l’URL du webhook générées dans votre compte WorkBright, remplissez les champs requis, puis cliquez sur Soumettre.',
  defaultSuccessMessage: 'Identifiants enregistrés avec succès !',
};
